export class AssetCullOutReportRequestModel {
    constructor() {
        this.teamId = "";
        this.assetCategoryId = "";
        this.assetTypeId = "";
        this.isTeam = false;
        this.assetTypeProperty = [];
    }
}
export default class AssetCullOutReportRequest extends AssetCullOutReportRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
